import { RaterAccountsState } from "./types";

export const defaultState = (): RaterAccountsState => {
  return {
    status: null,
    resetResult: null,
    makingApiRequest: false,
    lastUpdate: null
  };
};

export const state = defaultState();
